import { request } from '/@/axios/request'

// 获取授权
export function getAuth(params, options) {
  return request(`https://auth.iwxcms.com/index/getAuthInfo`, params, options, 'get')
}

// 获取授权网站插件列表
export function getAuthPluginList(params, options) {
  return request(`https://auth.iwxcms.com/plugin/getList`, {
    ...params,
    orderBy: 'id',
    orderType: 'desc'
  }, options, 'get')
}

// 获取授权网站插件详情
export function getAuthPluginDetail(params, options) {
  return request(`https://auth.iwxcms.com/plugin/getOne`, params, options, 'get')
}

// 获取最新版本号
export function getLatestVersion(params, options) {
  return request(`https://auth.iwxcms.com/index/getLatestVersion`, params, options, 'get')
}

// 获取版本列表
export function getVersionList(params, options) {
  return request(`https://auth.iwxcms.com/index/getVersionList`, params, options, 'get')
}
